const { isMobile } = require("./lib/breakpoints");
var pym = require("./lib/pym");
require("./lib/webfonts");

var d3 = {
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-scale/dist/d3-scale.min"),
};

var { COLORS } = require("./lib/helpers");

var pymChild;
var renderLineChart = require("./renderLineChart");

var charts = null;

//Initialize graphic
var onWindowLoaded = function() {
  formatData();
  render();

  window.addEventListener("resize", () => render());

  pym.then(child => {
    pymChild = child;
    child.sendHeight();
  });
};

//Format graphic data for processing by D3.
var formatData = function() {
  charts = Object.keys(DATA);

  charts.forEach(function(region, i) {
    var regionData = DATA[region].data;
    var series = [];

    // Restructure tabular data for easier charting.
    for (var column in regionData[0]) {
      if (column == "week") continue;

      series.push({
        name: column,
        values: regionData.map(d => ({
          date: d.week,
          amt: d[column]
        }))
      });
    }

    DATA[region].series = series;
  });
};

// Render the graphic(s). Called by pym with the container width.
var render = function() {
  // Render the chart!
  var container = "#line-chart";
  var element = document.querySelector(container);
  element.innerHTML = "";
  var width = element.offsetWidth;

  var chartsAcross = 4;
  var leftMargin = 5;
  var leftMarginWide = 40;
  var gutterWidth = 22;

  if (width <= 500) {
    chartsAcross = 2;
  } else if (width <= 650) {
    chartsAcross = 3;
  }
  var graphicWidth = Math.floor((width - (gutterWidth * chartsAcross) - leftMarginWide - (leftMargin * (chartsAcross - 1))) / chartsAcross);

  var colorScale = d3
    .scaleOrdinal()
    .domain(
      DATA.r1.series.map(function(d) {
        return d.name;
      })
    )
    .range([
      // grays plus red
      // "#DDD",
      // "#CCC",
      // "#BBB",
      // "#AAA",
      // "#999",
      // COLORS.red3

      // with thanks to color brewer
      "#b3e2cd",
      "#fdcdac",
      "#cbd5e8",
      "#f4cae4",
      "#e6f5c9",
      // "#fff2ae",
      "#333"

    ]);
  
  // Render the HTML legend.
  var containerElement = d3.select(container);

  var legend = containerElement
    .append("ul")
    .attr("class", "key")
    .selectAll("g")
    .data(colorScale.domain())
    .enter()
    .append("li")
    .attr("class", d => "key-item y-");

  legend.append("b").style("background-color", d => colorScale(d));
  legend.append("label").text(d => d);
  
  // draw the charts
  charts.forEach(function(region, i) {
    var thisChart = DATA[region];
    var thisTitle = thisChart.title;
    var thisData = thisChart.series;
    var thisAnnotations = ANNOTATIONS.filter(function(annot) {
      return annot.region == region;
    });

    var showYAxisLabels = false;
    var thisGraphicWidth = graphicWidth + leftMargin;
    var thisLeftMargin = leftMargin;
    if ((i % chartsAcross) == 0) {
      showYAxisLabels = true;
      thisGraphicWidth = graphicWidth + leftMarginWide;
      thisLeftMargin = leftMarginWide;
    }

    containerElement.append("div")
      .attr("class", `chart ${ region }`)
      .attr('style', `width: ${ thisGraphicWidth }px;`);

    renderLineChart({
      container: `.chart.${ region }`,
      width: thisGraphicWidth,
      data: thisData,
      annotations: thisAnnotations,
      dateColumn: "date",
      valueColumn: "amt",
      xDomain: [ 1, 53 ],
      yDomain: [ 0, 1500 ],
      title: thisTitle,
      colorScale,
      showYAxisLabels,
      marginLeft: thisLeftMargin
    });
  
  });

  // make all the subheds the same height so things line up more nicely
  var labelHeds = d3.selectAll('h3');
  var labelMaxHeight = 0;

  labelHeds["_groups"][0].forEach(function(d,i) {
      var thisHeight = d.getBoundingClientRect().height;
      if (thisHeight > labelMaxHeight) {
          labelMaxHeight = thisHeight;
      }
  });

  labelHeds.style('height', labelMaxHeight + 'px');

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);